var loadPhotoGallery;

$(function(){

  loadPhotoGallery = {
    page : 1,
    loading : false,
    finished : false,
    textSearch: textSearch,

    formataResumo: function(descricao){
      return descricao.replace(/(<([^>]+)>)/gi, "").substr(0,300);
    },

    formataImg : function(img){
      return (img) ? `/api/v1/diminuator?file=socialmedia/images/${img}&w=500&h=625` : 'icon-conectassma-white.png';
    },

    analytics: function(){
      let loadPhotoGallery = document.getElementsByClassName('loading');
      if (typeof gtag === "function" && loadPhotoGallery.length > 0) {
          gtag('event', 'page_view', {
              'event_category': 'events',
              'event_label': 'Page ' + loadPhotoGallery.page,
              'value': 1
          });
      }
    },

    load: function(){
      if(loadPhotoGallery.finished) return;
      $(".loading").fadeIn();
      loadPhotoGallery.loading = true;
      loadPhotoGallery.page = loadPhotoGallery.page + 1;
      $.ajax({
        dataType: "json",
        url: loadPhotoGallery.textSearch == "" ? `/api/v1/photogallery/${loadPhotoGallery.page}/` : `/api/v1/photogallery/${loadPhotoGallery.textSearch}/${loadPhotoGallery.page}/`,
        success: function(req){
          if (req[1].photogallery.length == 0) {
            loadPhotoGallery.finished = true;
          } else {
            //advertising
            let ad = req[0].advertising[0];
            let ad_template = `<div class="cell large-12 ultra-banner">
                              <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                              <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                              </div>`;
            $(".lista-fotos").append(ad_template);
            $.get(`/api/advertising-views/${ad.id}/`)
            //photogallery
            $(req[1].photogallery).each(function(ix, ft){
              let template = `
                <div class="cell large-3 medium-3 small-6">
                  <div class="foto">
                    <div class="box">
                      <div class="icon ${ft.account}"></div>
                      <div class="nome"><a href="/redirect/instagram/?url=${ft.url}" target="_blank">@${ft.owner_username}</a></div>
                    </div>
                    <a href="/redirect/instagram/?url=${ft.url}" target="_blank">
                      <img src="${loadPhotoGallery.formataImg(ft.image_local)}" alt="${ft.owner_username}" />
                    </a>
                  </div>
                </div>
              `
            $(".lista-fotos").append(template);
            })
          }
          $(".loading").fadeOut();
          loadPhotoGallery.analytics();
          loadPhotoGallery.loading = false;
        }
      });
    },

    search: function(div){
        var search = $(`.search-form.${div} #searchText`).val().toString();
        if(!search){
            document.location.href = `/galeria-de-fotos/`;
        } else {
            document.location.href = `/galeria-de-fotos/${search}/`;
        }
    }
  };

  $(".search-form.desktop .icon").click(function(){
    $(".search-form .form").animate({width:'toggle'},350);
    $("#searchText").focus();
  });

  $(".search-form.desktop #btnOk").click(function(){ loadPhotoGallery.search('desktop'); });
  $(".search-form.mobile #btnOk").click(function(){ loadPhotoGallery.search('mobile'); });

  $(".search-form.desktop #searchText").on('keypress',function(e) {
    if(e.which == 13) $(".search-form.desktop #btnOk").click()
  });


  if(textSearch){
    $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
    $(".search-form").addClass("search")
  }

  window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadPhotoGallery.loading === false) {
        loadPhotoGallery.load();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };

});

$("#back-to-top").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow", function() {
    $('#back-to-top').removeClass('visible');
  });
});
